import axiosInstance from "../api/axiosInstance"
import { useQuery } from "@tanstack/react-query"
import useAuthStore from "../stores/AuthStore"

const fetchProfile = () => {
    return axiosInstance.get("/profile")
}

export const  useProfile = () => {

    const { isLogged } = useAuthStore((state) => {
        return {
            isLogged: state.isLogged
        }
    })

    return useQuery({
        queryKey: ["profile"],
        enabled: isLogged,
        queryFn: fetchProfile,
        select: (data) => data.data,
        refetchInterval: (query) => {
          const kycStatus = query.state.data?.data?.kyc_status;
          return kycStatus === "green" ? false : 5000; 
        },
      });
    };